var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ScatterChart',{attrs:{"chart-data":_vm.datacollection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }